import { gql } from 'graphql-request';

const updateStoreCourierSettings = gql`
  mutation(
    $autoAssignMechanism: AutoAssignMechanismFromEnum
    $courierId: Int!
    $driverMaxCapacity: Int
    $networkFees: Float
    $storeId: Int!
    $assignmentFlow: AssignmentFlowFromEnum
  ) {
    updateStoreCourierSettings(
      autoAssignMechanism: $autoAssignMechanism
      courierId: $courierId
      driverMaxCapacity: $driverMaxCapacity
      storeId: $storeId
      assignmentFlow: $assignmentFlow
      networkFees: $networkFees
    ) {
      storeCourierSettings {
        id
        driverMaxCapacity
        autoAssignMechanism
        networkFees
      }
    }
  }
`;

export default updateStoreCourierSettings;
